import React from 'react';
import { Participant } from '../../types';
import './ResultsPodium.scss';

interface ResultsPodiumProps {
  participants: Participant[];
}

const PRIZE_ICONS = {
  Cruise: '🚢',
  iPhone: '📱',
  Money: '💰',
};

export const ResultsPodium: React.FC<ResultsPodiumProps> = ({ participants }) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  };

  const getAvatarColor = (position: number) => {
    switch (position) {
      case 1:
        return '#A4D16D';
      case 2:
        return '#EC542D';
      case 3:
        return '#14B8A6';
      default:
        return '#1A92D0';
    }
  };

  return (
    <div className="results-podium">
      {participants.map((participant) => (
        <div key={participant.id} className="podium-card">
          <div className="card-avatar">
            <div
              className="avatar"
              style={{ backgroundColor: getAvatarColor(participant.position) }}
            >
              {getInitials(participant.name)}
            </div>
            <h3 className="participant-name">{participant.name}</h3>
          </div>
          <div className="card-content">
            <div className="prize-info">
              <span className="prize-name">
                {PRIZE_ICONS[participant.prize as keyof typeof PRIZE_ICONS]} {participant.prize}
              </span>
            </div>
            <div className="medal-position">{participant.medalIcon}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
